<template>
    <div class="h-full">
        <div v-if="transitionIn" key="in" class="absolute top-0 left-0" :class="transition" data-transition-in>
            <slot></slot>
        </div>

        <div
            v-else
            class="h-full flex flex-col justify-end mx-auto"
            :class="{ 'w-screen h-screen': !ambienteEditor, 'shadow-xl': fullscreen }"
            style="max-width: 600px"
        >
            <div
                class="relative h-full flex flex-col bg-gray-100 overflow-hidden"
                :class="{ 'rounded-lg': !fullscreen }"
            >
                <div key="out-header" class="text-white pt-4 px-4 pb-10 flex-shrink-0" :style="'background: ' + cor">
                    <div :class="transitionOut ? 'header-fade-out' : 'header-fade-in'">
                        <slot name="header"></slot>
                    </div>

                    <div class="absolute top-0 right-0 mt-1.5 mr-1.5">
                        <div class="flex items-center space-x-1">
                            <div
                                v-if="websocketConnectionStatus == 'off'"
                                :title="__('Conexão perdida. Reconectando...')"
                            >
                                <alo-icon icon="outline-refresh" class="w-4 h-4 animate-spin" />
                            </div>

                            <button
                                v-show="!fullscreen"
                                class="p-1 rounded hover:bg-black-20%"
                                :title="__('Minimizar')"
                                @click="minimize()"
                            >
                                <alo-icon icon="solid-minus" class="w-6 h-6" />
                            </button>

                            <button
                                v-if="
                                    hasCloseListener && (showClose === true || showClose === false ? showClose : true)
                                "
                                class="p-1 rounded hover:bg-black-20%"
                                @click="$emit('close')"
                            >
                                <alo-icon icon="outline-x" class="w-6 h-6" />
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    class="-mt-10 flex-grow overflow-auto flex flex-col"
                    :class="transition"
                    key="out"
                    :data-transition-out="transitionOut"
                >
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AlertasSonoros from '@App/Vue/Remote/Core/Users/AlertasSonoros.vue'
import { AMBIENTE_EDITOR } from '../Store/Store'

export default {
    components: { AlertasSonoros },
    props: {
        transition: String,
        showClose: {
            type: Boolean,
            required: false,
            default: null,
        },
    },
    mounted() {
        let inviteBottomMargin = this.$store.state.aparência.inviteBottomMargin
        Teclia.__postMessage('resize', {
            shadow: true,
            width: '400px',
            height: `calc(100vh - ${inviteBottomMargin * 2}px)`,
        })
    },
    computed: {
        ambienteEditor() {
            return this.$store.state.ambiente == AMBIENTE_EDITOR
        },

        focus() {
            return this.$store.state.focoJanela
        },

        fullscreen() {
            return this.$store.state.fullscreen
        },

        cor() {
            return this.$store.getters.corPrimária
        },

        transitionIn() {
            return this.transition && this.transition.indexOf('in') !== -1
        },

        transitionOut() {
            return this.transition && this.transition.indexOf('out') !== -1
        },

        hasCloseListener() {
            return this.$listeners && this.$listeners.close && this.$listeners.close != null
        },

        websocketConnectionStatus() {
            return this.$store.state.websocketConnectionStatus
        },
    },
    methods: {
        minimize() {
            this.$store.dispatch('minimize')
        },
    },
}
</script>